import api from './api';

export interface WorkChatResponse {
  content: string;
  tool_calls: Array<{
    tool_name: string;
    arguments: string;
    result: string;
    duration_ms: number;
  }>;
  session_id: string;
}

export async function sendWorkChatMessage(
  content: string,
  modelId?: string,
): Promise<WorkChatResponse> {
  const response = await api.post('/work/chat/messages', { content, model_id: modelId }, { timeout: 120000 });
  return response.data;
}

export async function getWorkChatMessages(): Promise<{
  messages: Array<{ role: string; content: string; tool_calls?: any[] }>;
  session_id: string;
}> {
  const response = await api.get('/work/chat/messages');
  return response.data;
}

export async function resetWorkChat(): Promise<void> {
  await api.post('/work/chat/reset');
}
